import { render } from "./HomeCompliance.vue?vue&type=template&id=2b2bfb80&scoped=true"
import script from "./HomeCompliance.vue?vue&type=script&lang=js"
export * from "./HomeCompliance.vue?vue&type=script&lang=js"

import "./HomeCompliance.vue?vue&type=style&index=0&id=2b2bfb80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2bfb80"]])

export default __exports__